import { render } from "./UserAssignmentList.vue?vue&type=template&id=4cc594c1&scoped=true"
import script from "./UserAssignmentList.vue?vue&type=script&lang=js"
export * from "./UserAssignmentList.vue?vue&type=script&lang=js"

import "./UserAssignmentList.vue?vue&type=style&index=0&id=4cc594c1&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc594c1"]])

export default __exports__